export const dp_s4 = '4px';
export const dp_s8 = '8px';
export const dp_s12 = '12px';
export const dp_s16 = '16px';
export const dp_s24 = '24px';
export const dp_s32 = '32px';
export const dp_s48 = '48px';
export const dp_s64 = '64px';
export const dp_s80 = '80px';
export const dp_s96 = '96px';
